import ProductFilter from "./product-filter"

export class EnumProductFilterModel extends ProductFilter {
  constructor(group, products) {
    super(group, "ENUM")

    products.forEach((product) => {
      product.enum_product_parameter_values.forEach((param) => {
        if (
          param.product_parameter_group.id === this._id &&
          !this._includesValue(this.values, param.value)
        ) {
          this.values.push(param.value)
        }
      })
    })

    this.updateValues([], products)
  }

  values = []
  selected = []
  _displayValues = []

  select(value) {
    if (
      !this._includesValue(this.values, value) ||
      this._includesValue(this.selected, value)
    )
      return
    this.selected.push(value)
    this._updated()
  }

  unselect(value) {
    const index = this._indexOf(this.selected, value)
    if (index === -1) return
    this.selected.splice(index, 1)
    this._updated(this.selected.length !== 0)
  }

  reset() {
    this.selected = []
    this._displayValues = this.values.map((v) => v)
    super.reset()
  }

  matches(product) {
    for (let i = 0; i < product.enum_product_parameter_values.length; i++) {
      const param = product.enum_product_parameter_values[i]
      if (param.product_parameter_group.id !== this._id) continue
      if (this._includesValue(this.selected, param.value)) return true
    }

    return false
  }

  hasEffectOn(product) {
    const index = product.enum_product_parameter_values.findIndex(
      (param) => param.product_parameter_group.id === this._id,
    )

    return index !== -1
  }

  /**
   * This function is called if the products list updates.
   * @param products new list of products
   * @param filteredProductsWithoutCurrent
   */
  updateValues(
    products,
    filteredProductsWithoutCurrent,
    marketFilter,
    preselectedMarkets,
  ) {
    super.updateValues(
      products,
      filteredProductsWithoutCurrent,
      marketFilter,
      preselectedMarkets,
    )

    const matches = []

    filteredProductsWithoutCurrent.forEach((product) => {
      product.enum_product_parameter_values.forEach((param) => {
        if (param.product_parameter_group.id !== this._id) return
        if (this._includesValue(matches, param.value)) return
        matches.push(param.value)
      })
    })

    this._displayValues = matches
  }

  isHidden() {
    return this._displayValues.length <= 1 || super.isHidden()
  }

  isSelected(value) {
    return this._includesValue(this.selected, value)
  }

  isDisabled(value) {
    return (
      !this._includesValue(this.selected, value) &&
      !this._includesValue(this._displayValues, value)
    )
  }

  getState() {
    return {
      ...super.getState(),
      selected: this.selected,
      _displayValues: this._displayValues,
    }
  }

  restoreState(state) {
    super.restoreState(state)
    this.selected = this.values.filter((val) =>
      this._includesValue(state.selected || [], val),
    )
    this._displayValues = this.values.filter((val) =>
      this._includesValue(state._displayValues || [], val),
    )
    this._isActive = this.selected.length > 0
  }

  _getSelected() {
    let val = []

    if (this._displayValues.length <= 1) {
      val = this._displayValues
    } else {
      val = this.selected
    }

    return val
  }
}
